// @flow

import * as React from 'react';
import styled from '@emotion/styled';
import { isInteger } from 'lodash/fp';

type Props = {
  name?: string,
  distance?: string,
  weather?: string,
  startTime: string,
  track?: string,
  places?: number,
  venue?: string,
  number: number
};

const defaultProps = {
  name: undefined,
  distance: undefined,
  weather: undefined,
  track: undefined,
  places: undefined,
  venue: undefined
};

const Wrapper = styled.div(({ theme }) => ({
  backgroundColor: theme.color.basis6,
  color: theme.color.basis1,
  fontSize: theme.fontSize.small,
  overflow: 'hidden',
  borderBottom: '2px solid',
  borderColor: theme.color.basis5,
  padding: '0.375em 0.5em'
}));

const Label = styled.span(({ theme }) => ({
  textTransform: 'uppercase',
  paddingRight: theme.spacing.xsmall,
  fontWeight: theme.fontWeight.demiBold,
  whiteSpace: 'nowrap'
}));

const Value = styled.span({
  whiteSpace: 'nowrap'
});

const GameInfo: React.FC<Props> = ({
  distance,
  weather,
  track,
  venue,
  name,
  number,
  places,
  startTime
}: Props) => (
  <Wrapper>
    <div>
      <Label>{`${venue} Race ${number}`.toUpperCase()}:</Label>
      {name && <span>{name}</span>}
    </div>
    <div className="columns is-mobile is-multiline">
      {distance && (
        <div className="column">
          <Label>Distance:</Label>
          <span>{distance}</span>
        </div>
      )}
      {track && (
        <div className="column">
          <Label>Track:</Label>
          <span>{track}</span>
        </div>
      )}
      {weather && (
        <div className="column">
          <Label>Weather:</Label>
          <span>{weather}</span>
        </div>
      )}
      {startTime && (
        <div className="column">
          <Label>Start time:</Label>
          <Value>{startTime}</Value>
        </div>
      )}
      {isInteger(places) && (
        <div className="column">
          <Label>#Places:</Label>
          <span>{places}</span>
        </div>
      )}
    </div>
  </Wrapper>
);

GameInfo.defaultProps = defaultProps;

export default GameInfo;
